import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Restaurant() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Restaurant Business Consulting</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/restv.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Maximize your restaurant’s potential with data-driven operational improvements, staff training, and enhanced customer experiences.</p>
                        <h2 style={{ fontWeight: 'bold' }}>Key Services</h2>
                        <p>
                            <ul>
                                <li><b>Menu analysis and pricing</b> <br /><br/></li>
                                <li><b>Inventory and waste control</b> <br /><br/></li>
                                <li><b>Technology integration (POS, reservations)</b> <br /><br/></li>
                                <li><b>Staff training and scheduling</b> <br/><br/></li>
                                <li><b>Customer experience enhancement</b></li>
                            </ul>
                        </p>
                        
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{ fontWeight: 'bold' }}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Improved profit margins
                                </li>
                                <li><span class="arrow">➤</span>Consistent quality service</li>
                                <li><span class="arrow">➤</span>Reduced staff turnover</li>
                                <li><span class="arrow">➤</span>Enhanced efficiency                               </li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/rest.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />

                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{ fontWeight: 'bold' }}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
